import type { WhatsappTemplate } from '../../../pages/settings/whatsapp/useWhatsappTemplate';

/**
 * Les premiers mots du message, tels qu'ils partiront — extrait de #19 §4/§7.
 *
 * Partagé entre la liste des modèles, l'étape de choix de réservation (aperçu
 * tronqué) et l'étape de vérification (repli si le modèle n'a pas de `text`).
 */
export function apercu(modele: WhatsappTemplate): string {
    const texte = (modele.text ?? '').replace(/\s+/g, ' ').trim();
    return texte || modele.name || modele.template_name;
}

/** `post_stay_review` → « Post stay review ». */
function humaniser(identifiant: string): string {
    const mots = identifiant.replace(/_/g, ' ').trim();
    return mots.charAt(0).toUpperCase() + mots.slice(1);
}

/**
 * Le nom affiché en titre de ligne — retour client 2026-09-25.
 *
 * `name` est le nom donné dans TriggerFlow, lisible par construction — sauf
 * quand il ne l'est pas : laissé vide, recopié depuis `template_name` (l'ID
 * Meta), ou lui-même en `snake_case`. Dans ces trois cas on humanise plutôt que
 * d'afficher l'identifiant technique brut.
 */
export function nomLisible(modele: WhatsappTemplate): string {
    const brut = (modele.name ?? '').trim();
    const estTechnique = !brut || brut === modele.template_name || /^[a-z0-9_]+$/.test(brut);
    return estTechnique ? humaniser(brut || modele.template_name) : brut;
}
